/* eslint-disable */
// prettier-ignore
import * as Types from '../../../../../../../../../graphql/__generated__';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InvestorContactSearch_InvestorContactPartsFragment = {
  readonly __typename?: 'InvestorFirmContact';
  readonly investorEmployeeId: string;
  readonly name: string;
  readonly email1?: string | null;
  readonly email2?: string | null;
};

export type InvestorContactSearch_InvestorFirmsGridPartsFragment = {
  readonly __typename?: 'InvestorFirmsGrid';
  readonly investorContacts?: {
    readonly __typename?: 'InvestorContactsCollectionSegment';
    readonly items?: ReadonlyArray<{
      readonly __typename?: 'InvestorFirmContact';
      readonly investorEmployeeId: string;
      readonly name: string;
      readonly email1?: string | null;
      readonly email2?: string | null;
    }> | null;
  } | null;
};

export type InvestorContactSearch_InvestorFirmsEmployeesQueryVariables = Types.Exact<{
  firmKey: Types.Scalars['String']['input'];
  isCoveredAccount: Types.Scalars['Boolean']['input'];
}>;

export type InvestorContactSearch_InvestorFirmsEmployeesQuery = {
  readonly __typename?: 'Query';
  readonly investorFirmsGrid?: {
    readonly __typename?: 'InvestorFirmsGridCollectionSegment';
    readonly items?: ReadonlyArray<{
      readonly __typename?: 'InvestorFirmsGrid';
      readonly investorContacts?: {
        readonly __typename?: 'InvestorContactsCollectionSegment';
        readonly items?: ReadonlyArray<{
          readonly __typename?: 'InvestorFirmContact';
          readonly investorEmployeeId: string;
          readonly name: string;
          readonly email1?: string | null;
          readonly email2?: string | null;
        }> | null;
      } | null;
    }> | null;
  } | null;
  readonly coveredInvestorFirmsGrid?: {
    readonly __typename?: 'CoveredInvestorFirmsGridCollectionSegment';
    readonly items?: ReadonlyArray<{
      readonly __typename?: 'InvestorFirmsGrid';
      readonly investorContacts?: {
        readonly __typename?: 'InvestorContactsCollectionSegment';
        readonly items?: ReadonlyArray<{
          readonly __typename?: 'InvestorFirmContact';
          readonly investorEmployeeId: string;
          readonly name: string;
          readonly email1?: string | null;
          readonly email2?: string | null;
        }> | null;
      } | null;
    }> | null;
  } | null;
};

export const InvestorContactSearch_InvestorContactPartsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InvestorContactSearch_InvestorContactParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InvestorFirmContact' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'investorEmployeeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email2' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const InvestorContactSearch_InvestorFirmsGridPartsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InvestorContactSearch_InvestorFirmsGridParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InvestorFirmsGrid' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'investorContacts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order' },
                value: {
                  kind: 'ListValue',
                  values: [
                    {
                      kind: 'ObjectValue',
                      fields: [
                        {
                          kind: 'ObjectField',
                          name: { kind: 'Name', value: 'name' },
                          value: { kind: 'EnumValue', value: 'ASC' },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'InvestorContactSearch_InvestorContactParts' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InvestorContactSearch_InvestorContactParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InvestorFirmContact' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'investorEmployeeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email2' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const InvestorContactSearch_InvestorFirmsEmployeesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'InvestorContactSearch_InvestorFirmsEmployees' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'firmKey' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isCoveredAccount' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'investorFirmsGrid' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'firmKey' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'firmKey' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'skip' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: { kind: 'Variable', name: { kind: 'Name', value: 'isCoveredAccount' } },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'InvestorContactSearch_InvestorFirmsGridParts',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'coveredInvestorFirmsGrid' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'firmKey' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'firmKey' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: { kind: 'Variable', name: { kind: 'Name', value: 'isCoveredAccount' } },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'InvestorContactSearch_InvestorFirmsGridParts',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InvestorContactSearch_InvestorContactParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InvestorFirmContact' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'investorEmployeeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email2' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InvestorContactSearch_InvestorFirmsGridParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InvestorFirmsGrid' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'investorContacts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order' },
                value: {
                  kind: 'ListValue',
                  values: [
                    {
                      kind: 'ObjectValue',
                      fields: [
                        {
                          kind: 'ObjectField',
                          name: { kind: 'Name', value: 'name' },
                          value: { kind: 'EnumValue', value: 'ASC' },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'InvestorContactSearch_InvestorContactParts' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useInvestorContactSearch_InvestorFirmsEmployeesQuery__
 *
 * To run a query within a React component, call `useInvestorContactSearch_InvestorFirmsEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestorContactSearch_InvestorFirmsEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestorContactSearch_InvestorFirmsEmployeesQuery({
 *   variables: {
 *      firmKey: // value for 'firmKey'
 *      isCoveredAccount: // value for 'isCoveredAccount'
 *   },
 * });
 */
export function useInvestorContactSearch_InvestorFirmsEmployeesQuery(
  baseOptions: Apollo.QueryHookOptions<
    InvestorContactSearch_InvestorFirmsEmployeesQuery,
    InvestorContactSearch_InvestorFirmsEmployeesQueryVariables
  > &
    (
      | { variables: InvestorContactSearch_InvestorFirmsEmployeesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    InvestorContactSearch_InvestorFirmsEmployeesQuery,
    InvestorContactSearch_InvestorFirmsEmployeesQueryVariables
  >(InvestorContactSearch_InvestorFirmsEmployeesDocument, options);
}
export function useInvestorContactSearch_InvestorFirmsEmployeesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InvestorContactSearch_InvestorFirmsEmployeesQuery,
    InvestorContactSearch_InvestorFirmsEmployeesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    InvestorContactSearch_InvestorFirmsEmployeesQuery,
    InvestorContactSearch_InvestorFirmsEmployeesQueryVariables
  >(InvestorContactSearch_InvestorFirmsEmployeesDocument, options);
}
// @ts-ignore
export function useInvestorContactSearch_InvestorFirmsEmployeesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    InvestorContactSearch_InvestorFirmsEmployeesQuery,
    InvestorContactSearch_InvestorFirmsEmployeesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  InvestorContactSearch_InvestorFirmsEmployeesQuery,
  InvestorContactSearch_InvestorFirmsEmployeesQueryVariables
>;
export function useInvestorContactSearch_InvestorFirmsEmployeesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InvestorContactSearch_InvestorFirmsEmployeesQuery,
        InvestorContactSearch_InvestorFirmsEmployeesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  InvestorContactSearch_InvestorFirmsEmployeesQuery | undefined,
  InvestorContactSearch_InvestorFirmsEmployeesQueryVariables
>;
export function useInvestorContactSearch_InvestorFirmsEmployeesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InvestorContactSearch_InvestorFirmsEmployeesQuery,
        InvestorContactSearch_InvestorFirmsEmployeesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    InvestorContactSearch_InvestorFirmsEmployeesQuery,
    InvestorContactSearch_InvestorFirmsEmployeesQueryVariables
  >(InvestorContactSearch_InvestorFirmsEmployeesDocument, options);
}
export type InvestorContactSearch_InvestorFirmsEmployeesQueryHookResult = ReturnType<
  typeof useInvestorContactSearch_InvestorFirmsEmployeesQuery
>;
export type InvestorContactSearch_InvestorFirmsEmployeesLazyQueryHookResult = ReturnType<
  typeof useInvestorContactSearch_InvestorFirmsEmployeesLazyQuery
>;
export type InvestorContactSearch_InvestorFirmsEmployeesSuspenseQueryHookResult = ReturnType<
  typeof useInvestorContactSearch_InvestorFirmsEmployeesSuspenseQuery
>;
export type InvestorContactSearch_InvestorFirmsEmployeesQueryResult = Apollo.QueryResult<
  InvestorContactSearch_InvestorFirmsEmployeesQuery,
  InvestorContactSearch_InvestorFirmsEmployeesQueryVariables
>;

import { makeMockResponse } from '../../../../../../../../../graphql/mock-response';

export const makeInvestorContactSearch_InvestorFirmsEmployeesMockResponse = makeMockResponse<
  InvestorContactSearch_InvestorFirmsEmployeesQueryVariables,
  InvestorContactSearch_InvestorFirmsEmployeesQuery
>(InvestorContactSearch_InvestorFirmsEmployeesDocument);
